import React, { SyntheticEvent } from 'react'
import styled from '@emotion/styled'
import * as constants from 'view/styles/constants'
import { createStructuredSelector } from 'reselect'
import { currentOrganisationIdSelector } from 'selectors/adminSelectors'
import { SelectionActions } from 'store/selection'
import { connect } from 'react-redux'
import { iconSet } from 'view/components/icons'
import { MultiButton } from 'view/components/buttons'

interface GlobalNavigationButtonProps {
  organisationId: string | null
  caption: string
  closeOrganisationProfiles: (organisationIds: string[]) => unknown
  currentOrganisationId: string | null
  setOrganisationId: (organisationId: string | null) => unknown
}

const mapStateToProps = createStructuredSelector({
  currentOrganisationId: currentOrganisationIdSelector
})

const mapDispatchToProps = {
  setOrganisationId: SelectionActions.setOrganisationId,
  closeOrganisationProfiles: SelectionActions.closeOrganisationProfiles
}

const GlobalNavigationButton = styled.div<{ isActive: boolean }>`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100%;
  min-width: 90px;
  margin-right: 2px;
  padding: 0 3px;
  color: ${props => (props.isActive ? constants.CORE_PRIMARY_6 : constants.CORE_PRIMARY_1)};
  background-color: ${props => (props.isActive ? constants.CORE_PRIMARY : 'transparent')};
  font-size: 11px;
  font-weight: ${constants.FontWeight.SemiBold};
  svg {
    visibility: hidden;
  }
  &:hover {
    cursor: pointer;
  }
  &:hover svg {
    visibility: visible;
  }
`

const GlobalNavigationCloseIcon = styled(MultiButton)`
  position: absolute;
  top: 0px;
  right: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  svg {
    width: 8px;
    height: 8px;
  }
  &:hover {
    svg {
      color: ${constants.ACCENT_BAD};
    }
  }
`

class GlobalNavigationTabComponent extends React.Component<GlobalNavigationButtonProps> {
  render() {
    const { organisationId, caption, currentOrganisationId } = this.props

    return (
      <GlobalNavigationButton isActive={organisationId === currentOrganisationId} onClick={() => this.onOrganisationClick(organisationId)}>
        {caption}
        {organisationId !== null && (
          <GlobalNavigationCloseIcon onClick={event => this.onCloseOrganisationClick(event, organisationId)}>
            {iconSet.crossIcon}
          </GlobalNavigationCloseIcon>
        )}
      </GlobalNavigationButton>
    )
  }

  private onOrganisationClick = (organisationId: string | null) => {
    this.props.setOrganisationId(organisationId)
  }

  private onCloseOrganisationClick = (event: SyntheticEvent, organisationId: string | null) => {
    event.stopPropagation()
    if (organisationId) {
      this.props.closeOrganisationProfiles([organisationId])
    }
  }
}

export const GlobalNavigationTab = connect(mapStateToProps, mapDispatchToProps)(GlobalNavigationTabComponent)
